module.exports = __webpack_public_path__ + "img/white-outline-calendar-20x20.68030e96.svg";